<template>
  <div class="panel granary-right-panel">
    <div class="chart-box">
      <div ref="chart" class="chart"></div>
      <!-- 底座背景 -->
      <div class="bg"></div>
    </div>
    <!-- <img
      src="~@/assets/images/granary/xmy/echart6.png"
      alt=""
      class="echarts-img"
    /> -->
  </div>
</template>

<script>
// import * as echarts from "echarts";
// import "echarts-gl"; // 3d图表库(在 webpack 中配置后无需再import)
import { getPie3D } from "@/util/pieChart3d.js"; //工具类js
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
export default {
  data() {
    return {
      color: ["#ffdc4e", "#70c2ed", "#2782ef", "#03bdb9", "#ff7800"],
      optionData: [
        {
          name: "年出栏数1-49头",
          value: 22588
        },
        {
          name: "年出栏数50-99头",
          value: 5099
        },
        {
          name: "年出栏数100-499头",
          value: 6259
        },
        {
          name: "年出栏数500-999头",
          value: 1096
        },
        {
          name: "年出栏数1000-2999头",
          value: 637
        },
        {
          name: "年出栏数3000头以上",
          value: 141
        }
      ],
      statusChart: null,
      option: {}
    };
  },
  created() {
    // this.setLabel();
  },
  mounted() {
    this.statusChart = this.$echarts.init(this.$refs.chart);
    window.addEventListener("resize", () => {
      setTimeout(() => {
        this.statusChart.resize();
      }, 300);
    });
    this.initChart();
  },
  methods: {
    // 初始化label样式
    setLabel() {
      this.optionData.forEach((item, index) => {
        item.itemStyle = {
          color: this.color[index]
        };
        item.label = {
          normal: {
            show: true,
            color: this.color[index],
            //formatter: ["{b|{b}}", "{c|{c}}{b|台}", "{d|{d}%}"].join("\n"), // 用\n来换行
            formatter: "{d|{d}}{a|%}\n{b|{b}}",
            rich: {
              d: {
                fontFamily: "electronicFont",
                fontSize: 16,
                // color: "#fff"
                verticalAlign: "bottom"
              },
              a: {
                fontSize: 12,
                verticalAlign: "bottom",
                padding: [0, 0, 0, 2]
              },
              b: {
                color: "#fff",
                fontSize: 12
              }
              // b: {
              //   color: "#fff",
              //   lineHeight: 25,
              //   align: "left"
              // },
              // c: {
              //   fontSize: 22,
              //   color: "#fff",
              //   textShadowColor: "#1c90a6",
              //   textShadowOffsetX: 0,
              //   textShadowOffsetY: 2,
              //   textShadowBlur: 5
              // },
              // d: {
              //   color: this.color[index],
              //   align: "left"
              // }
            }
          }
        };
        item.labelLine = {
          normal: {
            lineStyle: {
              width: 1,
              color: this.color[index]
            }
          }
        };
      });
    },
    // 图表初始化
    initChart() {
      get("/api/dp/visual/queryList?code=sygm").then(res => {
        const { item, data } = res;
        if (Array.isArray(data) && data.length > 0) {
          const _dt = data[0];
          this.optionData.map(e => {
            const index = findIndexByName(e.name, item, "name");
            if (~index) {
              const code = item[index].code;
              e.value = Number(_dt[code]);
            }
            return e;
          });
          this.setLabel();
          // 传入数据生成 option, 构建3d饼状图, 参数工具文件已经备注的很详细
          this.option = getPie3D(this.optionData, 0.8, 240, 28, 26, 0.8);
          this.statusChart.setOption(this.option);
          // 是否需要label指引线，如果要就添加一个透明的2d饼状图并调整角度使得labelLine和3d的饼状图对齐，并再次setOption
          this.option.series.push({
            name: "饲养规模", //自己根据场景修改
            backgroundColor: "transparent",
            type: "pie",
            labelLine: {
              // length: 20,
              // length2: 80,
              lineStyle: {
                // color: "#fff"
              }
            },
            label: {
              opacity: 1,
              fontSize: 13,
              lineHeight: 24
              // padding: [0, -80, 0, -80]
            },
            startAngle: -40, // 起始角度，支持范围[0, 360]。
            clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
            radius: ["20%", "50%"],
            center: ["50%", "50%"],
            data: this.optionData,
            itemStyle: {
              opacity: 0 //这里必须是0，不然2d的图会覆盖在表面
            }
          });
          this.statusChart.setOption(this.option);
        }
      });
      // this.statusChart = echarts.init(this.$refs.chart); //要用eharts5
      // this.bindListen(this.statusChart)
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
    position relative
    .bg
      position absolute
      bottom 50px
      left 50%
      z-index -1
      width 180px
      height 73px
      background url('~images/granary/xmy/chart_opacity_bg.png') no-repeat center
      background-size 100% 100%
      transform translateX(-50%)

  .echarts-img
    height 230px
    margin 0 auto
    display block
</style>
